import type { OrganizationList } from 'models';
import { useTranslation } from 'react-i18next';
import { DataCard } from 'ui';
import { images } from 'common/utils';
import { useGetOrganizationIcon, useGetOrganizationTag } from '../../hooks';

type P = {
  getPathToOrganizationDetail: (id: string) => string;
  organization: OrganizationList;
  showTag?: boolean;
};

const OrganizationCard = ({ getPathToOrganizationDetail, organization, showTag = true }: P) => {
  const { t } = useTranslation();
  const getOrganizationTag = useGetOrganizationTag();
  const getOrganizationIcon = useGetOrganizationIcon();

  return (
    <DataCard
      image={{
        alt: 'Organization cover image',
        src: organization.coverPhoto?.url ?? images.default.organizationCoverPhoto,
      }}
      participantsProperties={{
        count: organization.membersCount,
        label: (formattedMembersCount) =>
          t('formattedMembersCount', { count: organization.membersCount, formattedCount: formattedMembersCount }),
      }}
      path={getPathToOrganizationDetail(organization.id)}
      tag={
        showTag
          ? { children: getOrganizationTag({ organization }), icon: getOrganizationIcon({ organization }) }
          : undefined
      }
      title={organization.name}
    />
  );
};

export default OrganizationCard;
